import Platform from './Platform'
import App from '../App'

class Android extends Platform {
  constructor() {
    super()
  }

  // iOS 下禁用页面滑动反弹
  toggleBouncesOff() {
    console.warn('安卓不支持bounces off')
  }

  // iOS 下启用页面滑动反弹
  toggleBouncesOn() {
    console.warn('安卓不支持bounces on')
  }

  /**
    * 预加载storeKit
    * @param params
    * @returns {*|Promise<any>}
    */
  preloadStoreKit (params = {}) {
    console.warn('安卓不支持preloadStoreKit')
  }

  /**
  * 添加stk到父视图
  * @param params
  * @returns {*|Promise<any>}
  */
  addStoreKitTo (params = {}) {
    console.warn('安卓不支持addStoreKitTo')
  }

  /**
   * 为increaseOfferFrequenceForRvIv接口组成要发送的数据
   * @param campaign {Object}
   */
  prepareDataForIncOfferFreRvIv(campaign = {}) {
    const dataSend = {
      unitId: App.unit.id,
      id: campaign.id,
      fcb: campaign.fcb,
      fca: campaign.fca,
      only_impression_url: campaign.only_impression_url,
    }
    return dataSend
  }
}

export default Android